module.exports = __webpack_public_path__ + "static/img/evening.df5df06.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/timelog/evening.png
// module id = IyYQ
// module chunks = 0